import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./pending-users-actions.scss";
import { MUITable } from "../../../../common/components";
import { userReportsHeaders } from "../user-reports-utils";

const PendingUsersActions = (props: any) => {
  const { userPendingActionsData, handleAddLeadReports, enableExport } =
    props;
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });
  const handleExport = async () => {
    try {
      handleAddLeadReports(
        { imageData: "" },
        { section: "user-pending-actions", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };
  const formatPendingSteps = (steps: string[]) => {
    return steps ? (Array.isArray(steps) ? steps.join(", ") : steps) : "-";
  };
  return (
    <Box className="pending-users-actions">
      <Box className="cpl-wrapper">
        <Box
          sx={{
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p className="header-text">Pending User Actions</p>
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Select
              options={[
                { value: "pdf", label: "PDF" },
                { value: "csv", label: "CSV" },
              ]}
              isSearchable={false}
              onChange={(e: any) => setFileFormat(e)}
              value={fileFormat}
              className="select-dropdown"
              components={{
                IndicatorSeparator: () => null, // ⛔️ removes vertical line
                DropdownIndicator: (props) => {
                  return (
                    <components.DropdownIndicator {...props}>
                      <ArrowDropDownIcon
                        style={{ fontSize: 20, color: "black" }}
                      />
                    </components.DropdownIndicator>
                  );
                },
              }}
            />
            <Button
              variant="outlined"
              onClick={handleExport}
              className="address-edit-button"
              disabled={!enableExport}
            >
              Export
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          padding: "10px 20px",
          overflowX: "auto",
        }}
      >
        <MUITable
          headers={userReportsHeaders}
          data={
            userPendingActionsData?.length
              ? userPendingActionsData?.map((data: any) => {
                  return {
                    ...data,
                    userName: data?.username || "-",
                    email: data?.email || "-",
                    pendingSteps: formatPendingSteps(data?.pendingSteps) || "-",
                  };
                })
              : []
          }
          isStriped={false}
        />
      </Box>
    </Box>
  );
};

export default PendingUsersActions;
